import { useAxios } from "@/composables";
import { CREATED } from "@/utils/enums/http-codes";
import PrivacyService from "@/utils/services/PrivacyService";

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function usePrivacyServiceRequest
 * @desc     A composable that provides a simple way of calling the Privacy Service's requests.
 *           The type paramater determines which request. Access is used for the user to request
 *           an email containing their user data, and Delete is for deleting their account.
 *
 * @summary  Composable used to call Privacy Service requests
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @param type Which type of privacy request to be made: "access" for user data request, "delete" for account deletion request.
 * @return An object containing success true or false, as well as a message property that is an empty string or error message.
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const usePrivacyServiceRequest = () => {
  const axios = useAxios();
  const privacyService = new PrivacyService(axios);
  return async function PrivacyRequest(type: "access" | "delete") {
    try {
      const response = await privacyService[type === "access" ? "subjectAccess" : "deleteAccount"]();
      return { success: response.status === CREATED };
    } catch (error) {
      return { success: false, message: (error as Error)?.message ?? "" };
    }
  };
};
